import React from 'react';
import ReactDOM from 'react-dom/client';
import CollectionForm from './component/collection/collectionForm';
import { RecoilRoot } from 'recoil';
import DrawService from './service/DrawService';
import { collectionModal } from './collectionModal';

export class CollectionPlugin {
  constructor(mymap, options = {}) {
    this.map = mymap;

    const {
      api_collection,
      rep_file,
      api_pci,
      ban_uri,
      user_data,
      localdata = false,
      containerId = null,
      buttonposition = null,
      featureGroup = null,
      layerController = null,
      sharedCollection = false,
      modeleCollection = false,
      onParcellesFetched = null,
      initGeocoder = false,
      fileTypesLinks = {},
      externalResources = {},
      zoomPadding = { paddingTopLeft: [800, 0] } // Format Leaflet: paddingTopLeft et paddingBottomRight
    } = options;

    if (initGeocoder && externalResources) {
      this.loadResources(externalResources);
    }

    if (localdata && (!api_collection || !user_data)) {
      throw new Error("api_collection et user_data sont requis.");
    }

    this.onParcellesFetched = onParcellesFetched;    
    this.featureGroup = featureGroup || L.featureGroup();
    this.layerController = layerController;
    DrawService.init(this.map,this.featureGroup,layerController, { zoomPadding });

    // ID unique pour montage React
    const mountId = 'leaflet-collection-root';

    if (containerId) {
      this._renderReact(`#${containerId}`, localdata, api_collection, rep_file, api_pci, ban_uri, user_data, sharedCollection, modeleCollection, onParcellesFetched, initGeocoder, fileTypesLinks, containerId);
    } else {
      // bouton leaflet pour ouvrir une popup
      const optionsbut = {};
      if (buttonposition) {  
        optionsbut.position = buttonposition;
      }
      const button = L.control(optionsbut);

      button.onAdd = () => {
        const div = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        div.innerHTML = '<button id="openFormBtn">📝</button>';
        return div;
      };

      button.addTo(this.map);

      const popup = document.createElement('div');
      popup.id = 'formPopup';
      popup.style.position = 'absolute';
      popup.style.top = '50px';
      popup.style.left = '50px';
      popup.style.width = '320px';
      popup.style.zIndex = 9999;
      popup.style.background = 'white';
      popup.style.border = '1px solid #ccc';
      popup.style.padding = '10px';
      popup.style.display = 'none';
      popup.style.maxHeight = (window.innerHeight - 70) + 'px'; 
      popup.style.overflowY = 'auto';
      popup.style.overflowX = 'hidden';
      popup.innerHTML = `<div id="${mountId}"></div>`;

      document.body.appendChild(popup);

      document.addEventListener('click', (e) => {
        if (e.target.id === 'openFormBtn') {
          const popup = document.getElementById('formPopup');
          const button = document.getElementById('openFormBtn');
          if (popup && button) {
            const rect = button.getBoundingClientRect();
            const screenWidth = window.innerWidth;
            const showToLeft = rect.left > screenWidth / 2;
            const left = showToLeft
            ? rect.left - 330 + window.scrollX 
            : rect.right + 10 + window.scrollX; 
      
            popup.style.left = `${left}px`;
            const isVisible = popup.style.display === 'block';
            popup.style.display = isVisible ? 'none' : 'block';
          }
        }
      });

      this._renderReact(`#${mountId}`, localdata, api_collection, rep_file, api_pci, ban_uri, user_data, sharedCollection, modeleCollection, onParcellesFetched, initGeocoder, fileTypesLinks, containerId);
    }
    window.pluginCollection = this;
  }
  
  loadResources(resources) {
    const { scripts = [], styles = [] } = resources || {};
  
    styles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  
    scripts.forEach(src => {
      if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement('script');
        script.src = src;
        script.async = false; // pour garder l'ordre
        document.body.appendChild(script);
      }
    });
  }

  _renderReact(selector, localdata, api_collection, rep_file, api_pci, ban_uri, user_data, sharedCollection, modeleCollection, onParcellesFetched, initGeocoder, fileTypesLinks, containerId) {
    const container = document.querySelector(selector);
    const root = ReactDOM.createRoot(container);
    root.render(
      <RecoilRoot>
        <CollectionForm
          localdata={localdata}
          api_collection={api_collection}
          rep_file={rep_file}
          api_pci={api_pci}
          ban_uri={ban_uri}
          user_data={user_data}
          sharedCollection={sharedCollection}
          modeleCollection={modeleCollection}
          onParcellesFetched={onParcellesFetched}
          initGeocoder={initGeocoder}
          fileTypesLinks={fileTypesLinks}
          mymap={this.map}
          containerId={containerId}
          featureGroup={this.featureGroup}
        />
      </RecoilRoot>
    );
  }

  // Nouvelle méthode pour déclencher le reload
  openColletionModal(param) {
    const event = new CustomEvent("reloadAllListe", {
      detail: param
    });
    window.dispatchEvent(event);
  }
  
}

window.CollectionPlugin = CollectionPlugin;

window.modalCollection = collectionModal;